const HISTORY_MAX_ENTRIES = 50

const CONFLICT_GROUP_BY_TAB = {
    RECETTE: "SECTIONS",
    ETAPES_PROD: "SECTIONS",
    DETAILS: "DETAILS",
    GENERAL: "GENERAL",
    // "Remarques et actualité" only writes its own field: tracing it must not raise a conflict on the "Général" form
    REMARQUES: "REMARQUES"
}

export const getSaveConflictGroup = (tab) => CONFLICT_GROUP_BY_TAB[tab] || tab

export const getSaveEntryKey = (entry) => entry.id || `${entry.date}|${entry.tab}|${entry.user?.objectId}`

export const getSaveHistoryKeys = (history) => (history || []).map(getSaveEntryKey)

export const findSaveConflict = ({ history, tab, sessionId, knownKeys }) => {
    if (!knownKeys) return null

    const group = getSaveConflictGroup(tab)
    const known = new Set(knownKeys)
    const unseen = (history || []).filter(entry =>
        getSaveConflictGroup(entry.tab) === group &&
        entry.sessionId !== sessionId &&
        !known.has(getSaveEntryKey(entry))
    )

    if (!unseen.length) return null

    return {
        conflictEntry: unseen[unseen.length - 1],
        unseenKeys: unseen.map(getSaveEntryKey)
    }
}

const sanitizeEntry = (entry) => entry.user
    ? { ...entry, user: { objectId: entry.user.objectId, username: entry.user.username } }
    : entry

export const buildNextSaveHistory = (history, newEntry) => {
    return [...(history || []).map(sanitizeEntry), newEntry].slice(-HISTORY_MAX_ENTRIES)
}
